import { createRouter, createWebHistory } from "vue-router";
import SignUp from "../views/SignUp.vue";
import SignIn from "../views/SignIn.vue";
import VerifySignIn from "../views/VerifySignIn.vue";
import Landing from "../views/Landing.vue";
import DashBoard from "@/views/Dashboard.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Landing,
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUp,
  },
  {
    path: "/signin",
    name: "signin",
    component: SignIn,
  },
  {
    path: "/verify",
    name: "verify",
    component: VerifySignIn,
  },
  {
    path: "/dashboard",
    name: "DashBoard",
    component: DashBoard,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
